module.exports = __webpack_public_path__ + "img/gate_ready.bd536b6.svg";